export type SocialLink = {
  label: string;
  url: string;
};

export type SiteContact = {
  company: string;
  address: string;
  phone: string;
  email: string;
};

export const siteTagline =
  'Shaping the future with smart, scalable solutions. Our custom services empower businesses to grow, perform, and thrive globally';

export const siteContact: SiteContact = {
  company: 'OUNIC LIMITED',
  address: '49294 - 00100 Nairobi, Kenya',
  phone: '+254 720 255 774',
  email: 'ask@ounic.co',
};

export const socialLinks: SocialLink[] = [
  { label: 'X', url: 'https://twitter.com/ounic_' },
  { label: 'GitHub', url: 'https://github.com/ounic-ke' },
  { label: 'LinkedIn', url: 'https://www.linkedin.com/company/ounic' },
];

export const copyrightYear = 2026;

export const mailchimpSubscribeUrl =
  'https://ounic.us19.list-manage.com/subscribe/post-json?u=a3393ec1ad65df81330d5e936&id=d2df73154e&f_id=001b5de7f0';

export const mailchimpHoneypotField = 'b_a3393ec1ad65df81330d5e936_d2df73154e';
